import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    AdminComponent,
    AdminDashboardComponent,
    SidebarComponent,
    HeaderComponent,
  ],
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    AdminRoutingModule
  ],
  providers: [
  ],
  exports: [
    AdminComponent
  ]
})

export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts